import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";

function handleEditProjectStatusRequest(
  project: Identifiable<Project>,
  req: Boundaries["editProjectStatus"]["request"],
): Identifiable<Project> {
  return project.status && project.status.uuid === req.status.uuid
    ? {
        ...project,
        status: { ...req.status, ...req.nextStatus },
      }
    : project;
}

function handleEditProjectStatusSuccess(
  project: Identifiable<Project>,
  req: Boundaries["editProjectStatus"]["success"],
): Identifiable<Project> {
  return project.status && project.status.uuid === req.status.uuid
    ? {
        ...project,
        status: req.status,
      }
    : project;
}

function handleEditProjectStatusFailure(
  project: Identifiable<Project>,
  req: Boundaries["editProjectStatus"]["failure"],
): Identifiable<Project> {
  return project.status && project.status.uuid === req.status.uuid
    ? { ...project, status: req.status }
    : project;
}

export {
  handleEditProjectStatusRequest,
  handleEditProjectStatusSuccess,
  handleEditProjectStatusFailure,
};
